import { useContext, useEffect, useState } from "react";
import { Modal } from "../../components";
import { useModal } from "../../hooks";
import { StatusChip } from "../../utils/chipUtils";
import { regexService, userService } from "../../service";
import { notificationContext } from "../../context/context";
import dateFormat from "../../utils/dateFormat";

function UserList() {
  const toast = useContext(notificationContext);
  const { isModal, showModal, hideModal } = useModal();
  const [isLoading, setLoading] = useState(true);

  const [userData, setUserData] = useState([]);
  const [newUserData, setNewUserData] = useState({});

  const [searchValue, setSearchValue] = useState("");
  const [searchList, setSearchList] = useState([]);

  const submitUser = () => {
    const response = userService.createNewUser(newUserData);

    if (response.error) {
      hideModal();
      toast.error(response.error.message);
    } else {
      toast.success(response.data.message);
    }

    hideModal();
  };

  const getUserList = async () => {
    const response = await userService.getUserList();

    if (response.error) {
      if (response.error.code != 101) {
        toast.error(response.error.message);
      }
    } else {
      setUserData(response.data);
      setSearchList(response.data);
    }
    setLoading(false);
  };

  const setInputValue = (e) => {
    setNewUserData({
      ...newUserData,
      [e.target.id]: e.target.value,
    });
  };

  const handleSearch = () => {
    setLoading(true);
    if (searchValue?.length == 0) {
      setSearchList(userData);
      return;
    }
    const data =
      userData?.filter((e) =>
        e.name?.toString()?.toUpperCase().match(searchValue?.toUpperCase())
      ) || [];
    setSearchList(data);
    setLoading(false);
  };

  useEffect(() => {
    if (searchValue?.length == 0) {
      setSearchList(userData);
    }
  }, [searchValue]);

  useEffect(() => {
    getUserList();
  }, []);

  return (
    <div>
      <div className="flex-nowrap flex-center justify-content-between">
        <h5>All User {userData?.length > 0 && `(${userData.length})`}</h5>
        {/* <button className="btn--sm btn-primary" onClick={showModal}>
          <span class="material-symbols-rounded">add</span>Add New User
        </button> */}
      </div>
      <div className="mt-2">
        <div className="fc-nowrap flex-center justify-content-between mt-4">
          <label className="input input--sm fc-4">
            <input
              type="text"
              id="searchvalue"
              placeholder="Search by Username"
              value={searchValue}
              onChange={(e) =>
                regexService.isName(e.target.value) &&
                setSearchValue(e.target.value)
              }
            />
            <button
              className="btn--xs btn-primary"
              onClick={() => {
                handleSearch();
              }}
            >
              <span class="material-symbols-rounded">search</span>
            </button>
          </label>
        </div>
        <div className="cover border rounded-border-sm mt-3">
          <table>
            <thead>
              <tr>
                <th>Username</th>
                <th>UserID</th>
                <th>EmailID</th>
                <th>Role</th>
                <th>Created on</th>
                <th>Status</th>
              </tr>
            </thead>
            {searchList?.length > 0 && (
              <tbody className="table-body">
                {searchList?.map((data) => (
                  <tr>
                    <td className="f-500">{data?.name}</td>
                    <td>{data?.userid}</td>
                    <td>{data?.mailid}</td>
                    <td>{data?.role}</td>
                    <td>{dateFormat(data?.createddt)}</td>
                    <td>
                      <StatusChip status={data?.isactive} />
                    </td>
                    {/* <td>
                    <div className="list-icon">
                      <span class="material-symbols-rounded">edit</span>
                    </div>
                  </td> */}
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          {(isLoading && <div className="no-records">Loading...</div>) ||
            (searchList?.length == 0 && (
              <div className="no-records">No Records to display</div>
            ))}
        </div>
      </div>
      {isModal && (
        <Modal>
          <div className="modal-wrapper">
            <div className="side-modal">
              <div className="modal-head">
                <h5>Add New User</h5>
                <div className="list-icon" onClick={hideModal}>
                  <span class="material-symbols-rounded">close</span>
                </div>
              </div>
              <div className="modal-body overflow-y-auto">
                <div className="input-wrapper">
                  <p className="input-title">UserID</p>
                  <label className="input">
                    <input
                      type="text"
                      placeholder="Enter your userid"
                      id="userid"
                      value={newUserData?.userid}
                      onChange={(e) => setInputValue(e)}
                    />
                  </label>
                </div>
                <div className="input-wrapper">
                  <p className="input-title">User Name</p>
                  <label className="input">
                    <input
                      type="text"
                      placeholder="Enter your username"
                      id="username"
                      value={newUserData?.username}
                      onChange={(e) => setInputValue(e)}
                    />
                  </label>
                </div>
                <div className="input-wrapper">
                  <p className="input-title">Email ID</p>
                  <label className="input">
                    <input
                      type="text"
                      placeholder="Enter your email id"
                      id="emailid"
                      value={newUserData?.emailid}
                      onChange={(e) => setInputValue(e)}
                    />
                  </label>
                </div>
                <div className="input-wrapper">
                  <p className="input-title">Role</p>
                  <label className="select">
                    <select
                      id="userrole"
                      value={newUserData?.role}
                      onChange={(e) => setInputValue(e)}
                    >
                      <option value="role1">Role 1</option>
                      <option value="role2">Role 2</option>
                    </select>
                  </label>
                </div>
                <div className="input-wrapper">
                  <p className="input-title">Status</p>
                  <div className="flex-center gap-lg">
                    <label className="input-radio">
                      <input
                        type="radio"
                        name="status"
                        className="mr-1"
                        id="userstatus"
                        value="active"
                        checked={
                          (newUserData.userstatus == "active" && true) || false
                        }
                        onChange={(e) => setInputValue(e)}
                      />
                      Active
                    </label>
                    <label className="input-radio">
                      <input
                        type="radio"
                        name="status"
                        className="mr-1"
                        value="inactive"
                        checked={
                          (newUserData.userstatus == "inactive" && true) ||
                          false
                        }
                        id="userstatus"
                        onChange={(e) => setInputValue(e)}
                      />
                      InActive
                    </label>
                  </div>
                </div>
              </div>
              <div className="modal-foot justify-content-end">
                <button className="btn-primary" onClick={submitUser}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default UserList;
